import { Controller } from '@hotwired/stimulus';
import Sortable from '../../libs/sortable.js';
import appNoty from '../../libs/appNoty';

export default class extends Controller {
  static targets = ['container', 'boardButtonsContainer', 'viewCount', 'form'];
  static values = {
    imagesUploadUrl: String,
  };

  static BOARD_COMPONENT_CLASSES =
    'board-component drag-handle border-coolgray-300 hover:bg-coolgray-50 flex flex-col justify-between items-cente';

  static TEXT_COMPONENT_CLASSES =
    'text-component drag-handle border-coolgray-300 hover:bg-coolgray-50 flex flex-col justify-between items-center';
  static TEXT_PREVIEW_CLASSES = 'w-full hidden h-auto py-4';
  static TEXT_PREVIEW_BUTTON_CLASSES =
    'bg-primary-700 text-white text-base rounded px-4 py-2 my-2 hover:bg-primary-800';

  static BANNER_COMPONENT_CLASSES =
    'banner-component drag-handle border-coolgray-300 hover:bg-coolgray-50 flex flex-col justify-between items-center ';

  connect() {
    this.initializeSortable();
    this.updatePositions();
  }
  initializeSortable() {
    Sortable.create(this.containerTarget, {
      animation: 150,
      handle: '.drag-handle',
      onEnd: this.handleDragEnd.bind(this),
    });
  }
  getImgSrc(component, imageType) {
    const imageElement = component.querySelector(`#${imageType}-preview-img`);
    const datasetKey = `${imageType}Image`;

    if (component.dataset[datasetKey]) {
      return 'link,' + component.dataset[datasetKey];
    }

    return imageElement.src;
  }
  validateImage(component, imageType, errorMessage) {
    const imgSrc = this.getImgSrc(component, imageType);

    if (!imgSrc) {
      const message = errorMessage || `Please insert ${imageType} image.`;
      appNoty(message, 'alert').show();
    }
  }

  validateBanner(component) {
    this.validateImage(component, 'desktop', 'PC용 배너 이미지를 넣어주세요.');
    this.validateImage(component, 'mobile', '모바일용 이미지를 넣어주세요.');
  }

  getViewCount(component) {
    if (component.dataset.type !== 'BOARD') {
      return 0;
    }
    const viewCount = component.querySelector('input[type="radio"]:checked');
    if (viewCount !== null) {
      return viewCount.value;
    } else {
      if (component.dataset.boardType === 'MEET') return 2;
      if (component.dataset.boardType === 'NEWS') {
        if (component.dataset.viewmode === 'CARD') {
          return 5;
        } else {
          return 4;
        }
      }
      return 3;
    }
  }

  saveComponent(event) {
    const form = this.formTarget;
    const formData = new FormData(form);
    const container = this.containerTarget;
    const components = container.childNodes;
    const componentData = [];
    Array.from(components).forEach((component, index) => {
      if (component.tagName === 'DIV' && component.dataset.type) {
        if (component.dataset.type === 'BANNER') {
          this.validateBanner(component);
        }
        if (component.dataset.type === 'TEXT') {
          this.insertTextToPreview(component);
        }
        const data = {
          type: component.dataset.type,
          position: index,
          content: component.dataset.type === 'TEXT' ? this.getTextContent(component) : '',
          desktop_image: component.dataset.type === 'BANNER' ? this.getImgSrc(component, 'desktop') : '',
          mobile_image: component.dataset.type === 'BANNER' ? this.getImgSrc(component, 'mobile') : '',
          board_id: component.dataset.type === 'BOARD' ? component.dataset.boardId : '',
          target_link: component.dataset.type === 'BANNER' ? component.querySelector('#target-link-input').value : '',
          view_count: this.getViewCount(component),
          banner_new_window:
            component.dataset.type === 'BANNER' ? component.querySelector('input[type=checkbox]').checked : true,
          banner_use_background_color:
            component.dataset.type === 'BANNER'
              ? component.querySelector('#use-background-color-checkbox').querySelector('input[type=checkbox]').checked
              : null,
          banner_background_color:
            component.dataset.type === 'BANNER'
              ? component.querySelector('#background-color-picker').querySelector('input[type=color]').value
              : '#000000',
          banner_stretch:
            component.dataset.type === 'BANNER'
              ? component.querySelector('#stretch-checkbox').querySelector('input[type=checkbox]').checked
              : null,
        };
        componentData.push(data);
      }
    });

    formData.append('componentData', JSON.stringify(componentData));

    axios
      .post(form.action, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        const result = response.data;
        const message = this.messageValue || '저장되었습니다.';
        appNoty(message, 'alert').show();
        console.log('Save result:', result);
      })
      .catch((error) => {
        const result = response.data;
        const message = this.messageValue || '저장에 실패했습니다.';
        appNoty(message, 'alert').show();
        console.error('Failed to save component:', error);
      });
  }

  handleDragEnd(event) {
    const { oldIndex, newIndex } = event;
    const components = Array.from(this.containerTarget.children);

    const [removed] = components.splice(oldIndex, 1);

    components.splice(oldIndex, 0, removed);

    this.containerTarget.innerHTML = '';
    components.forEach((component) => {
      this.containerTarget.appendChild(component);
      component.setAttribute('draggable', 'true');
      if (component.querySelector('textarea')) {
        const editorController = this.application.getControllerForElementAndIdentifier(
          component.querySelector('textarea'),
          'editor',
        );
        if (editorController !== null) {
          editorController.disconnect();
          editorController.connect();
        }
      }
      if (component.querySelector('table')) {
        const nodes = component.querySelectorAll('[data-controller="image-preview"]');

        nodes.forEach((node) => {
          const controller = this.application.getControllerForElementAndIdentifier(node, 'image-preview');
          if (controller !== null) {
            controller.connect();
          }
        });
      }
    });

    this.updatePositions();
  }

  addComponent(event) {
    const componentType = event.currentTarget.dataset.type;
    let newComponent;

    switch (componentType) {
      case 'TEXT':
        newComponent = this.addTextComponent();
        break;
      case 'BANNER':
        newComponent = this.addBannerComponent();
        break;
      case 'BOARD':
        const board = event.currentTarget.dataset;
        newComponent = this.addBoardComponent(board, event.currentTarget);
        break;
      default:
        alert('Unknown component type');
        break;
    }
    if (newComponent) {
      const position = this.containerTarget.children.length + 1;
      newComponent.setAttribute('data-position', position);
      newComponent.setAttribute('th:attr', `data-position='[[${position}]]'`);
      newComponent.setAttribute('draggable', true);
      this.containerTarget.appendChild(newComponent);
    }
  }

  getTitleComponent(name, isFoldable) {
    const titleComponent = document.createElement('div');
    titleComponent.className = 'w-full ml-0 flex border-y border-coolgray-300 p-4';

    const leftComponent = document.createElement('div');
    leftComponent.className = 'flex items-center space-x-4';

    const dotComponent = document.createElement('div');
    dotComponent.className = 'ml-0 w-[2rem] h-[2rem] bg-cover bg-icon-6dot';

    const nameComponent = document.createElement('div');
    nameComponent.className = 'text-coolgray-700 board-name font-bold text-lg';
    nameComponent.textContent = name;

    leftComponent.appendChild(dotComponent);
    leftComponent.appendChild(nameComponent);

    const rightComponent = document.createElement('div');
    rightComponent.className = 'flex items-center space-x-4 ml-auto';

    if (isFoldable) {
      const foldButton = document.createElement('button');
      foldButton.className = 'bg-cover bg-icon-unfold w-8 h-8 ';
      foldButton.setAttribute('data-accordion-target', 'button');
      foldButton.dataset.action = 'click->accordion#toggle';
      rightComponent.appendChild(foldButton);
    }

    const deleteButton = document.createElement('button');

    deleteButton.className = 'bg-cover bg-icon-delete w-8 h-8 ';
    deleteButton.dataset.action = 'click->component#deleteComponent';

    rightComponent.appendChild(deleteButton);

    titleComponent.appendChild(leftComponent);
    titleComponent.appendChild(rightComponent);

    return titleComponent;
  }

  getCountOptions(board) {
    if (board.boardType === 'MEET') return [2, 4, 8];
    if (board.boardType === 'NEWS') {
      if (board.viewmode === 'CARD') {
        return [5, 9, 13];
      } else {
        return [4, 8, 12];
      }
    }
    return [3, 6, 9];
  }

  addBoardComponent(board, button) {
    if (!board.boardId) return;

    if (this.isBoardComponentExists(board.boardId)) {
      const result = response.data;
      const message = this.messageValue || '이미 메인 화면에 들어가 있습니다.';
      appNoty(message, 'alert').show();
      return;
    }
    const newComponent = document.createElement('div');
    newComponent.className = this.constructor.BOARD_COMPONENT_CLASSES;
    newComponent.dataset.boardId = board.boardId;
    newComponent.dataset.type = 'BOARD';
    newComponent.dataset.boardType = board.boardType;
    newComponent.dataset.name = board.name;
    newComponent.setAttribute('data-controller', 'accordion');
    newComponent.setAttribute('data-accordion-open-class', 'bg-icon-unfold');
    newComponent.setAttribute('data-accordion-close-class', 'bg-icon-fold');
    newComponent.setAttribute('draggable', 'true');

    newComponent.appendChild(this.getTitleComponent(board.name, board.boardType !== 'INTRO'));

    const contentWrapper = document.createElement('div');
    contentWrapper.setAttribute('data-accordion-target', 'content');
    contentWrapper.className = 'flex flex-row w-full h-auto border-b hidden';

    const contentHeader = document.createElement('div');
    contentHeader.className = 'w-[16.5rem] bg-[#d1d4db] text-base font-bold px-4 py-4';
    contentHeader.innerText = '노출되는 컨텐츠의 수';
    const contentHeaderIcon = document.createElement('i');
    contentHeaderIcon.className = "ml-1 not-italic text-red-600 before:content-['*']";
    const contentHeaderIconSpan = document.createElement('span');
    contentHeaderIconSpan.className = 'hidden-text';
    contentHeaderIcon.appendChild(contentHeaderIconSpan);
    contentHeader.appendChild(contentHeaderIcon);
    contentWrapper.appendChild(contentHeader);

    const contentBody = document.createElement('div');
    contentBody.className = 'w-full flex flex-row justify-center py-4 bg-white divide-x';
    contentBody.setAttribute('data-board-type', 'board.boardType}');

    const countOptions = this.getCountOptions(board); // Change this according to your actual count options

    countOptions.forEach((count) => {
      const countWrapper = document.createElement('div');
      countWrapper.className = 'w-1/3 flex flex-col px-4';
      countWrapper.setAttribute('for', `${board.boardId + '-' + count}`);

      const countInputWrapper = document.createElement('div');
      countInputWrapper.className = 'flex justify-center';

      const countInput = document.createElement('input');
      countInput.setAttribute('type', 'radio');
      countInput.setAttribute('name', `${'viewCount-' + board.boardId}`);
      countInput.setAttribute('id', `${board.boardId + '-' + count}`);
      countInput.setAttribute('value', count);
      if (count === 3) {
        countInput.setAttribute('checked', count === 3);
      }

      const countLabel = document.createElement('label');
      countLabel.textContent = `${count}개`;
      countLabel.setAttribute('for', `${board.boardId + '-' + count}`);

      countInputWrapper.appendChild(countInput);
      countInputWrapper.appendChild(countLabel);
      countWrapper.appendChild(countInputWrapper);

      contentBody.appendChild(countWrapper);
    });

    contentWrapper.appendChild(contentBody);
    newComponent.appendChild(contentWrapper);

    this.containerTarget.appendChild(newComponent);

    if (button) {
      button.remove();
    }
  }

  isBoardComponentExists(boardId) {
    const existingComponents = this.containerTarget.getElementsByClassName('board-component');
    for (let i = 0; i < existingComponents.length; i++) {
      const component = existingComponents[i];
      if (component.dataset.boardId === boardId) {
        return true;
      }
    }
    return false;
  }

  getBannerRow(title, altText, imageSize) {
    const componentCount = document.querySelectorAll('.board-component, .text-component, .banner-component').length;

    const bannerRow = document.createElement('tr');

    bannerRow.className = 'border-b border-[#d1d4db] w-full';
    const bannerTitleTh = document.createElement('th');
    bannerTitleTh.className =
      'min-h-[18rem] py-4 bg-[#f3f3f6] align-top text-base pl-4 break-keep whitespace-nowrap text-left';
    bannerTitleTh.setAttribute('scope', 'row');
    bannerTitleTh.textContent = title;
    const bannerItalic = document.createElement('i');
    bannerItalic.className = "ml-1 not-italic text-red-600 before:content-['*']";
    const bannerItalicSpan = document.createElement('span');
    bannerItalicSpan.classList.add('hidden-text');
    bannerItalicSpan.textContent = '필수';
    bannerItalic.appendChild(bannerItalicSpan);
    bannerTitleTh.appendChild(bannerItalic);
    bannerRow.appendChild(bannerTitleTh);
    const bannerTd = document.createElement('td');
    bannerTd.className = 'min-h-[18rem]  py-6 px-4 align-top w-full flex flex-col justify-center';

    bannerTd.setAttribute('data-controller', 'image-preview');
    const bannerDiv = document.createElement('div');
    bannerDiv.className =
      'rounded border border-dashed border-[#d1d4db] px-[2.5rem] py-[1.5rem] flex flex-col space-y-3';

    const bannerImgDiv = document.createElement('div');

    if (imageSize === 'desktop') {
      bannerImgDiv.className = 'w-[26rem] rounded inline-block relative bg-coolgray-200';
    } else if (imageSize === 'mobile') {
      bannerImgDiv.className = 'rounded inline-block relative bg-coolgray-400 w-[10rem]';
    }
    const bannerImg = document.createElement('img');
    if (imageSize === 'desktop') {
      bannerImg.className = 'w-[26rem] rounded';
    } else if (imageSize === 'mobile') {
      bannerImg.className = 'rounded bg-contain';
    }

    bannerImg.setAttribute('alt', altText);
    bannerImg.setAttribute('id', `${imageSize}-preview-img`);
    bannerImg.setAttribute('data-image-preview-target', 'output');
    bannerImg.setAttribute('data-type', `${imageSize}`);
    bannerImgDiv.appendChild(bannerImg);

    const bannerButton = document.createElement('button');
    bannerButton.setAttribute('id', `${imageSize}-remove-button`);
    bannerButton.setAttribute('type', 'button');
    bannerButton.setAttribute('data-action', 'click->component#deleteImage');
    bannerButton.className = 'absolute top-2 right-2 w-8 h-8 bg-coolgray-500 rounded-[50%]';

    const bannerButtonSpan = document.createElement('span');
    bannerButtonSpan.className = 'xi-close mt-[2px] text-base text-white remove_file';
    bannerButtonSpan.setAttribute('id', `${imageSize}Banner`);
    const bannerButtonSpanHidden = document.createElement('span');
    bannerButtonSpanHidden.classList.add('hidden-text');
    bannerButtonSpanHidden.textContent = '배너삭제';
    bannerButtonSpan.appendChild(bannerButtonSpanHidden);
    bannerButton.appendChild(bannerButtonSpan);

    bannerImgDiv.appendChild(bannerButton);

    bannerDiv.appendChild(bannerImgDiv);

    const bannerFileDiv = document.createElement('div');
    bannerFileDiv.className = 'flex my-[0.75rem]';

    const fileInputContainer = document.createElement('div');
    fileInputContainer.classList.add('mt-2');

    const fileInput = document.createElement('input');
    fileInput.setAttribute('type', 'file');
    fileInput.setAttribute('id', `${imageSize}-file-input-${componentCount + 1}`);

    fileInput.setAttribute('name', `${imageSize}BannerFile`);
    fileInput.setAttribute('data-action', 'change->component#onChangeImage');
    fileInput.classList.add('hidden');

    const fileInputLabel = document.createElement('label');
    fileInputLabel.setAttribute('for', `${imageSize}-file-input-${componentCount + 1}`);
    fileInputLabel.className =
      'text-base rounded border border-coolgray-300 py-2 px-3 text-coolgray-600 cursor-pointer';

    const clipSpan = document.createElement('span');
    clipSpan.className = 'bg-clip bg-cover w-4 h-4 inline-block mr-2';

    fileInputLabel.appendChild(clipSpan);
    fileInputLabel.appendChild(document.createTextNode('파일 선택'));

    fileInputContainer.appendChild(fileInput);
    fileInputContainer.appendChild(fileInputLabel);

    bannerFileDiv.appendChild(fileInputContainer);
    bannerDiv.appendChild(bannerFileDiv);

    const bannerWarnDiv = document.createElement('div');
    bannerWarnDiv.className = 'flex flex-row items-center';

    const bannerSignDiv = document.createElement('div');
    bannerSignDiv.className = 'w-4 h-4 bg-exclamation bg-cover';
    const bannerWarnSpan = document.createElement('div');
    bannerWarnSpan.className = 'text-md text-[#6b7280]';
    if (imageSize === 'desktop') {
      bannerWarnSpan.textContent = 'PC 배너 이미지 2232*688 사이즈를 준수해서 올려주세요.';
    } else if (imageSize === 'mobile') {
      bannerWarnSpan.textContent = 'Mobile 배너 이미지 720*832 사이즈를 준수해서 올려주세요.';
    }

    bannerWarnDiv.appendChild(bannerSignDiv);
    bannerWarnDiv.appendChild(bannerWarnSpan);

    bannerDiv.appendChild(bannerWarnDiv);

    if (imageSize === 'desktop') {
      const newCheckBoxComponent = document.createElement('div');
      newCheckBoxComponent.className = 'flex flex-col lg:flex-row lg:items-center lg:space-x-4';

      const colorDivComponent = document.createElement('div');
      colorDivComponent.className = 'flex items-center space-x-2 mt-3 lg:mt-0';
      colorDivComponent.setAttribute('id', 'background-color-picker');

      const useBackgroundColorLabel = document.createElement('label');
      useBackgroundColorLabel.setAttribute('for', `use-background-color-${componentCount + 1}`);
      useBackgroundColorLabel.textContent = '배경색 선택:';

      const bannerBackgroundColorInput = document.createElement('input');
      bannerBackgroundColorInput.setAttribute('type', 'color');
      bannerBackgroundColorInput.setAttribute('id', `use-background-color-${componentCount + 1}`);
      bannerBackgroundColorInput.setAttribute('name', 'bannerBackgroundColor');

      colorDivComponent.appendChild(useBackgroundColorLabel);
      colorDivComponent.appendChild(bannerBackgroundColorInput);

      const colorUseDivComponent = document.createElement('div');
      colorUseDivComponent.className = 'flex items-center space-x-2 mt-3 lg:mt-0';
      colorUseDivComponent.setAttribute('id', 'use-background-color-checkbox');

      const useBackgroundColorCheckbox = document.createElement('input');
      useBackgroundColorCheckbox.setAttribute('type', 'checkbox');
      useBackgroundColorCheckbox.setAttribute('id', `use-background-color-checkbox-${componentCount + 1}`);
      useBackgroundColorCheckbox.setAttribute('name', 'bannerUseBackgroundColor');

      const bannerBackgroundColorLabel = document.createElement('label');
      bannerBackgroundColorLabel.setAttribute('for', `use-background-color-checkbox-${componentCount + 1}`);
      bannerBackgroundColorLabel.textContent = '배경색 사용';

      colorUseDivComponent.appendChild(useBackgroundColorCheckbox);
      colorUseDivComponent.appendChild(bannerBackgroundColorLabel);

      const stretchComponent = document.createElement('div');
      stretchComponent.className = 'flex items-center space-x-2 mt-3 lg:mt-0';
      stretchComponent.setAttribute('id', 'stretch-checkbox');

      const bannerStretchCheckbox = document.createElement('input');
      bannerStretchCheckbox.setAttribute('type', 'checkbox');
      bannerStretchCheckbox.setAttribute('id', `stretch-checkbox-${componentCount + 1}`);
      bannerStretchCheckbox.setAttribute('name', 'bannerStretch');

      const bannerStretchLabel = document.createElement('label');
      bannerStretchLabel.setAttribute('for', `stretch-checkbox-${componentCount + 1}`);
      bannerStretchLabel.textContent = '배너 늘이기';

      stretchComponent.appendChild(bannerStretchCheckbox);
      stretchComponent.appendChild(bannerStretchLabel);

      newCheckBoxComponent.appendChild(colorDivComponent);
      newCheckBoxComponent.appendChild(colorUseDivComponent);
      newCheckBoxComponent.appendChild(stretchComponent);

      bannerDiv.appendChild(newCheckBoxComponent);
    }

    bannerTd.appendChild(bannerDiv);

    bannerRow.appendChild(bannerTd);
    return bannerRow;
  }
  getTargetLinkRow() {
    const targetLinkRow = document.createElement('tr');
    targetLinkRow.className = 'border-b border-[#d1d4db] w-full';

    const targetLinkTh = document.createElement('th');
    targetLinkTh.className =
      'py-4 bg-[#f3f3f6] align-top text-base pl-4 pr-[11rem] break-keep whitespace-nowrap text-left';
    targetLinkTh.setAttribute('scope', 'row');
    targetLinkTh.textContent = '타겟 주소';

    const targetLinkTd = document.createElement('td');
    targetLinkTd.className = 'py-3 px-4 min-h-[5.7rem] flex flex-col';

    const targetLinkInput = document.createElement('input');

    targetLinkInput.className = 'w-[31rem] !h-[2.5rem] !rounded !py-[0.5rem] !px-[1rem] mb-[0.8rem]';
    targetLinkInput.setAttribute('type', 'text');
    targetLinkInput.setAttribute('id', 'target-link-input');
    targetLinkInput.setAttribute('name', 'targetLink');
    targetLinkInput.setAttribute('placeholder', 'http 또는 https를 포함한 URL을 입력하세요.');

    const position = this.containerTarget.children.length + 1;

    const newWindowCheckbox = document.createElement('input');
    newWindowCheckbox.setAttribute('type', 'checkbox');
    newWindowCheckbox.setAttribute('id', `new-window-checkbox-${position}`);
    newWindowCheckbox.setAttribute('name', 'bannerNewWindow');

    const newCheckBoxComponent = document.createElement('div');

    const newWindowLabel = document.createElement('label');
    newWindowLabel.setAttribute('for', `new-window-checkbox-${position}`);
    newWindowLabel.textContent = '새 창에서 열기';

    newCheckBoxComponent.appendChild(newWindowCheckbox); // Append the checkbox
    newCheckBoxComponent.appendChild(newWindowLabel);

    targetLinkTd.appendChild(targetLinkInput);

    targetLinkTd.appendChild(newCheckBoxComponent);

    targetLinkRow.appendChild(targetLinkTh);
    targetLinkRow.appendChild(targetLinkTd);

    return targetLinkRow;
  }

  onChangeImage(event) {
    event.stopPropagation();
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const uploadedImage = e.target.result;
        const bannerImg = event.target.closest('tr').querySelector('img');

        const div = bannerImg.closest('.banner-component');

        const imgType = bannerImg.dataset.type;

        if (this.isURL(div.dataset[`${imgType}Image`])) {
          this.deleteImageFromServer(bannerImg).then(() => {
            bannerImg.setAttribute('src', uploadedImage);
            div.dataset[`${imgType}Image`] = '';
          });
        } else {
          bannerImg.setAttribute('src', uploadedImage);
          div.dataset[`${imgType}Image`] = '';
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  }

  addBannerComponent() {
    const bannerComponent = document.createElement('div');
    bannerComponent.className = this.constructor.BANNER_COMPONENT_CLASSES;
    bannerComponent.dataset.type = 'BANNER';
    bannerComponent.setAttribute('draggable', 'true');
    bannerComponent.setAttribute('data-controller', 'accordion');
    bannerComponent.setAttribute('data-accordion-open-class', 'bg-icon-unfold');
    bannerComponent.setAttribute('data-accordion-close-class', 'bg-icon-fold');

    bannerComponent.appendChild(this.getTitleComponent('배너추가', true));
    const tableComponent = document.createElement('table');
    tableComponent.className = 'hidden rounded w-full';
    tableComponent.setAttribute('data-accordion-target', 'content');
    tableComponent.appendChild(this.getTargetLinkRow());

    const pcBannerRow = this.getBannerRow('배너이미지 (PC)', '', 'desktop');
    tableComponent.appendChild(pcBannerRow);

    const mobileBannerRow = this.getBannerRow('배너이미지 (Mobile)', '', 'mobile');
    tableComponent.appendChild(mobileBannerRow);

    bannerComponent.appendChild(tableComponent);
    this.updatePositions();
    this.containerTarget.appendChild(bannerComponent);
  }

  updatePositions() {
    const components = Array.from(this.containerTarget.children);
    components.forEach((component, index) => {
      const position = index;
      component.setAttribute('data-position', position);
      component.setAttribute('draggable', 'true');
    });
  }

  getTextContent(component) {
    const iframe = component.querySelector('.tox-edit-area__iframe');
    if (iframe) {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      const mceElement = iframeDoc.querySelector('.mce-content-body');

      if (mceElement) {
        return mceElement.innerHTML;
      } else {
        return component.querySelector('textarea').value;
      }
    } else {
      return component.querySelector('textarea').value;
    }
    return '';
  }

  insertTextToPreview(component) {
    const htmlContent = this.getTextContent(component);
    const textPreview = component.querySelector('#text-preview');

    if (textPreview !== null && htmlContent !== null) {
      textPreview.innerHTML = htmlContent;
      textPreview.style.display = 'block';
    }
  }

  previewTextComponent(event) {
    event.preventDefault();
    this.insertTextToPreview(event.target.parentNode);
  }
  addTextComponent() {
    const newTextComponent = document.createElement('div');
    newTextComponent.className = this.constructor.TEXT_COMPONENT_CLASSES;
    newTextComponent.dataset.type = 'TEXT';
    newTextComponent.setAttribute('draggable', 'true');
    newTextComponent.setAttribute('data-controller', 'accordion');
    newTextComponent.setAttribute('data-accordion-open-class', 'bg-icon-unfold');
    newTextComponent.setAttribute('data-accordion-close-class', 'bg-icon-fold');
    newTextComponent.appendChild(this.getTitleComponent('직접입력', true));

    const contentComponent = document.createElement('div');
    contentComponent.className = 'px-4 bg-[#d1d4db] hidden rounded-b pt-4';
    contentComponent.setAttribute('data-accordion-target', 'content');

    const textPreview = document.createElement('div');
    textPreview.className = this.constructor.TEXT_PREVIEW_CLASSES;
    textPreview.setAttribute('id', 'text-preview');

    const textarea = document.createElement('textarea');
    textarea.className = `w-full hidden mt-4`;
    textarea.setAttribute('data-controller', 'editor');
    textarea.setAttribute('data-editor-target', 'field');
    textarea.setAttribute('placeholder', '게시판 설명을 적어주세요.');
    textarea.setAttribute('name', 'contents');
    textarea.setAttribute('data-editor-images-upload-url-value', this.imagesUploadUrlValue);

    const saveButton = document.createElement('button');
    saveButton.textContent = '미리보기';
    saveButton.className = this.constructor.TEXT_PREVIEW_BUTTON_CLASSES;
    saveButton.setAttribute('data-action', 'click->component#previewTextComponent');

    contentComponent.appendChild(textPreview);
    contentComponent.appendChild(textarea);
    contentComponent.appendChild(saveButton);

    newTextComponent.appendChild(contentComponent);

    this.updatePositions();
    this.containerTarget.appendChild(newTextComponent);
  }

  deleteComponent(event) {
    event.preventDefault();
    const deleteButton = event.target;
    const component = deleteButton.closest('.board-component, .text-component, .banner-component');
    if (component.classList.contains('board-component')) {
      const boardButtonsContainer = document.querySelector('.board-buttons-container');
      const buttonToInsert = document.createElement('button');
      buttonToInsert.className =
        'w-full py-2 text-[#373d51] text-center border-t border-x border-coolgray-300 hover:bg-coolgray-300ㅊ';

      buttonToInsert.textContent = `${component.querySelector('.board-name').textContent}`;
      buttonToInsert.dataset.type = 'BOARD';
      buttonToInsert.dataset.boardId = component.dataset.boardId;
      buttonToInsert.dataset.boardType = component.dataset.boardType;
      buttonToInsert.dataset.name = component.dataset.name;

      buttonToInsert.dataset.action = 'component#addComponent';

      const buttons = boardButtonsContainer.querySelectorAll('button[data-type="board"]');
      let inserted = false;

      for (let i = 0; i < buttons.length; i++) {
        const currentButton = buttons[i];
        if (currentButton.dataset.boardId > component.dataset.boardId) {
          boardButtonsContainer.insertBefore(buttonToInsert, currentButton);
          inserted = true;
          break;
        }
      }

      if (!inserted) {
        boardButtonsContainer.appendChild(buttonToInsert);
      }
    }
    component.remove();
  }

  isURL(url) {
    var urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/[\w.-]*)*\/?$/i;
    return urlPattern.test(url);
  }
  deleteImageFromServer(bannerImg) {
    const url = '/admin/manage-main/delete-banner-image'; // update this to the correct endpoint
    const data = {
      id: bannerImg.dataset.id, // update this to the correct data attribute
      type: bannerImg.dataset.type, // update this to the correct data attribute
    };

    return axios
      .get(url, { params: data })
      .then((response) => {
        const result = response.data;
        const message = this.messageValue || '이미지가 삭제되었습니다..';
        appNoty(message, 'alert').show();
        console.log('Deleted image result:', result);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  deleteImage(event) {
    event.preventDefault();
    const tdTag = event.target.closest('td');
    const img = tdTag.querySelector('img');
    const banner = img.closest('.banner-component'); // get the closest banner-component

    if (img === null || banner === null) {
      return;
    }

    const inputTag = tdTag.querySelector('input');
    inputTag.value = '';

    const bannerImg = banner.querySelector('img'); // get the img element within the banner-component
    if (this.isURL(bannerImg.getAttribute('src'))) {
      this.deleteImageFromServer(bannerImg).then(() => {
        bannerImg.setAttribute('src', '');
      });
    }

    img.setAttribute('src', '');
  }
}
